import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Banner from "../../components/Banner/Banner";
import banner from "../../images/News/Banners/banner.webp";
import tile1 from "../../images/News/Tiles/1.webp";
import tile2 from "../../images/News/Tiles/2.webp";
import tile3 from "../../images/News/Tiles/3.webp";
import tile4 from "../../images/News/Tiles/4.webp";
// import Content from "../../components/Content/Content";
import Heading from "../../components/Text/Heading";
import Footer from "../../components/Footer/Footer";
import Text from "../../components/Text/Text";
import BlogPost from "../../components/BlogPost/BlogPost";
import BlogPost2 from "../../components/BlogPost/BlogPost_2";
import BlogPost3 from "../../components/BlogPost/BlogPost_3";
import BlogPost4 from "../../components/BlogPost/BlogPost_4";
import { Grid,useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Actions from "../../components/appbar/actions";

const useStyles = makeStyles({
  mainSection: {
    backgroundColor: "#FFFFFF",
    margin: 0,
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "column",
  },
  row: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  rowMobile: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  textSectionWrapper: {
    display: "flex",
  },
  textSection: {
    padding: "0px 40px",
  },
  textSectionMobile: {
    padding: "0px",
  },
  textSectionBorder: {
    borderLeft: "2px solid #5669DA",
    margin: "20px 0px",
  },
});

export default function News({ scrollToRef }) {
  const classes = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <Grid>
      <div ref={scrollToRef}>
      <Banner background={banner} height={matches ? 500 : "unset"}>
        <>{matches ? <Heading color="#FFFFFF">Pressroom</Heading> :   
        <p style={{color:"#FFFFFF", fontSize: "10vw",padding: 30, margin: 0,  fontFamily:"Roboto",fontWeight : "bold"}}>Pressroom</p> }</>  
        </Banner>
      </div>
      <section id="mainSection" className={classes.mainSection}>
        <div className={classes.row}>
          <div
            style={{
              margin: matches ? 100 : 30,
              width: matches ? "70%" :"100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-end",
              alignItems: "flex-end",
              marginBottom : matches ? "unset" : 20
            }}
          >
            <div className={classes.textSectionWrapper}>
            <>{matches ? <div className={classes.textSectionBorder} /> : ""}
              </>
                <div className={matches ? classes.textSection : classes.textSectionMobile}>
                <Text style={{color: "#444444",fontWeight: 500, fontSize: matches ? "unset" : "4vw",marginTop: matches ? "unset" : 0, marginBottom: matches ? "unset" :0 }}>
                  The latest announcements, industry insights, and perspectives
                  from SYB. Delve into the latest issues and innovations driving
                  the future of the digital payment industry.
                </Text>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className={matches ? classes.row : classes.rowMobile}>
          <div
            style={{
              width: "100%",
            }}
          >
            <div
              style={{
                width: "-webkit-fill-available",
                marginInline: matches? 40 :   0,
                padding: matches ? "0px 40px 80px 40px" : "0",
                margin : matches ? "unset" : 30,
                display: "flex",
                flexDirection: "column",
                marginBottom: matches ? "unset" : 48
              }}
            >
              <>{matches ?<Heading variant="h3" style={{ margin: "1rem" }}>
                Publications
              </Heading>:   
               <p style={{color:"#1B297C", fontSize: "8vw",padding: 0, margin: "unset",  fontFamily:"Roboto",fontWeight : "bold"}}>Publications</p> }</>  
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "space-around",
                }}
              >
                <BlogPost
                  image={tile1}
                  date="21 December 2021"
                  title="BI-Fast officially launch, Interbank Transfer Fee becomes Rp 2.500"
                />
                <BlogPost2
                  image={tile2}
                  date="11 November 2021"
                  title="Indonesia's GoTo Group raises over $1.3B in first pre-IPO close"
                />
                <BlogPost3
                  image={tile3}
                  date="08 October 2021"
                  title="Akulaku Jack Ma officially becomes the controller of Bank Neo"
                />
                <BlogPost4 
                  image={tile4}
                  date="21 October 2021"
                  title="Becoming Bank Bisnis Controller, Kredivo injects Rp 439.69 billion"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <>{matches ? <Footer language="en" /> : <Actions/> }</>
    </Grid>
  );
}
